module.exports = __webpack_public_path__ + "img/treppenhaus.4cb57aba.webp";